import React, { useEffect, useState } from "react"
import { ThemeProvider, CssBaseline } from "@material-ui/core"
import { createMuiTheme } from "@material-ui/core/styles"
import { useLocation, useHistory } from "react-router-dom"
import queryString from "query-string"
import AdminUserApplicationListContainer from "../../containers/AdminContainer/AdminUserApplicationListContainer"
import services from "../../services"

function AdminUserApplicationListPage() {
  const location = useLocation()
  const history = useHistory()
  const queryParams = queryString.parse(location.search)
  
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [currentPage, setCurrentPage] = useState(parseInt(queryParams.page) || 1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [filters, setFilters] = useState({
    search: queryParams.search || "",
    status: queryParams.status || "",
    business_type: queryParams.business_type || "",
    business_category: queryParams.business_category || "",
    sort_by: queryParams.sort_by || "created_at",
    sort_order: queryParams.sort_order || "desc"
  })
  const perPage = 20

  const updateURL = (page, currentFilters) => {
    const params = {
      page: page > 1 ? page : undefined,
      search: currentFilters.search || undefined,
      status: currentFilters.status || undefined,
      business_type: currentFilters.business_type || undefined,
      business_category: currentFilters.business_category || undefined,
      sort_by: currentFilters.sort_by !== "created_at" ? currentFilters.sort_by : undefined,
      sort_order: currentFilters.sort_order !== "desc" ? currentFilters.sort_order : undefined,
    }
    
    // Remove undefined values
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key])
    
    const searchString = queryString.stringify(params)
    const newUrl = searchString ? `${location.pathname}?${searchString}` : location.pathname
    
    // Only update if URL actually changed
    if (location.pathname + location.search !== newUrl) {
      history.replace(newUrl)
    }
  }

  const fetchApplications = async (page, currentFilters = filters) => {
    try {
      setLoading(true)
      const filterParams = {}
      if (currentFilters.search) filterParams.search = currentFilters.search
      if (currentFilters.status) filterParams.status = currentFilters.status
      if (currentFilters.business_type) filterParams.business_type = currentFilters.business_type
      if (currentFilters.business_category) filterParams.business_category = currentFilters.business_category
      if (currentFilters.sort_by) filterParams.sort_by = currentFilters.sort_by
      if (currentFilters.sort_order) filterParams.sort_order = currentFilters.sort_order
      
      const response = await services.userApplicationServices.getUserApplications(page, perPage, filterParams)
      
      if (response && response.data) {
        const { data } = response.data
        setApplications(data.applications || [])
        setTotalPages(data.total_pages || 1)
        setTotalCount(data.total_count || 0)
        setCurrentPage(data.current_page || 1)
      } else {
        setApplications([])
        setTotalPages(1)
        setTotalCount(0)
        setCurrentPage(1)
      }
    } catch (err) {
      console.error('Error fetching applications:', err)
      setError(err.message || "Failed to load applications")
      setApplications([])
      setTotalPages(1)
      setTotalCount(0)
      setCurrentPage(1)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchApplications(currentPage, filters)
    updateURL(currentPage, filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filters])

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1) // Material-UI pagination is 0-based
  }

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
    setCurrentPage(1) // Reset to first page when filters change
  }

  const darkTheme = createMuiTheme({
    palette: {
      type: "dark",
    },
  })

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AdminUserApplicationListContainer 
        applications={applications}
        loading={loading}
        error={error}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        filters={filters}
        onFilterChange={handleFilterChange}
      />
    </ThemeProvider>
  )
}

export default AdminUserApplicationListPage